export { FlatList as FlashList } from 'react-native';
